export default __webpack_public_path__ + "static/media/double-arrow-up.b76cbd1f.svg";